var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtpl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 73,
    viewBox: "0 0 82 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.7134 2C67.7134 4.75917 67.5762 11.2432 67.0272 15.106C66.4782 18.9689 67.256 23.6135 67.7134 25.4529",
    stroke: "#43D48A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.731 14.4164C59.0184 13.4967 65.5149 11.9332 73.2009 13.0368C80.8868 14.1405 80.5208 14.4164 79.3771 14.4164",
    stroke: "#43D48A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63191 26.5926C9.97855 27.5457 12.8414 27.7364 16.7838 26.5926C20.7261 25.4489 24.5277 20.874 25.9356 18.7295C27.109 20.3974 30.0188 24.0192 32.2715 25.163C35.0875 26.5926 41.4234 27.3075 45.6473 25.163C49.8713 23.0185 48.4633 48.0376 47.0553 53.0414C45.6473 58.0452 33.6795 69.4825 28.0476 70.9121C22.4157 72.3418 4.11197 55.9007 3.40798 47.3227C2.84479 40.4603 2.23466 36.362 2 35.1706",
    stroke: "#43D48A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3291 35.4801C19.0638 36.1512 17.4187 36.0394 16.0702 35.4801H12.834V40.5135C12.9688 41.2125 13.3194 43.6174 13.643 47.644C14.0476 52.6774 24.5654 62.3246 27.8016 61.4857C31.0379 60.6468 37.9149 53.9357 38.724 50.9996C39.533 48.0635 40.3421 33.3829 37.9149 34.6412C35.4877 35.8996 31.8469 35.4801 30.2288 34.6412C28.9343 33.9701 27.2623 31.8449 26.588 30.8662C25.779 32.1245 23.5945 34.809 21.3291 35.4801Z",
    stroke: "#43D48A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtpl);
export default __webpack_public_path__ + "static/media/vtpl.1289f4b5b2e1ec29ee02a0978c0846a8.svg";
export { ForwardRef as ReactComponent };